import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OtpModalComponent } from '../authentication/otp-modal/otp-modal.component';
import { firstValueFrom } from 'rxjs';
import { SecondaryOtpService } from './secondary-otp.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OtpModalService {
  private secondaryOtpEnabled = environment?.settings?.secondaryOtpEnabled;

  constructor(
    private dialog: MatDialog,
    private secondaryOtpService: SecondaryOtpService,
  ) {}

  async ensureOtpVerified(): Promise<boolean> {
    if (!this.secondaryOtpEnabled) {
      return true;
    }

    if (this.secondaryOtpService.isOtpVerified) {
      return true;
    }

    const verified = await this.openOtpModal();
    return !!verified;
  }

  openOtpModal(): Promise<boolean> {
    const dialogRef = this.dialog.open(OtpModalComponent, {
      disableClose: true,
    });

    return firstValueFrom(dialogRef.afterClosed());
  }
}
